import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { storeQueries } from '@as-react/common-queries';
import { LocationSearchType, StoreFinderType } from '@as-react/common-types';
import { useQueries } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchAPI from '../../api/search/SearchAPI';
import { StoreFinderPopup } from '../../components/product-detail/store-finder-popup/StoreFinderPopup';
import { SELECTED_STORE_STORAGE_KEY } from '../../constants/StorageKeysConstants';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import { makeGetBasketCCPopupState } from '../../redux/basket/selectors/BasketSelector';
import { listerActions } from '../../redux/lister/actions/ListerActions.creators';
import { makeGetInStoreFilterState } from '../../redux/lister/selectors/ListerSelector';
import { urlActions } from '../../redux/url/actions/UrlActions.creators';
import { makeGetStoreId, makeGetUrlQueryInformationState } from '../../redux/url/selectors/UrlSelectors';
import LocalStorageUtil from '../../util/LocalStorageUtil';
const InStoreFilterPopupContainer = () => {
    var _a;
    const popupState = useSelector(makeGetBasketCCPopupState());
    const urlInfo = useSelector(makeGetUrlQueryInformationState());
    const inStoreFilterState = useSelector(makeGetInStoreFilterState());
    const activeStoreId = useSelector(makeGetStoreId());
    const dispatch = useDispatch();
    const { defaultRequestParams, servicesEndpoint, authenticationConfig, isShopLanding } = useAemConfig();
    const [locationSearchParams, setLocationSearchParams] = useState();
    const { getClickAndCollectStores } = storeQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const isEnabled = !popupState.collapsed &&
        !!((_a = locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch) === null || _a === void 0 ? void 0 : _a.location) &&
        locationSearchParams.locationSearch.state !== 'INIT';
    const storesQueryResult = useQueries({
        queries: [
            getClickAndCollectStores({
                location: ((locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch) || {}).location,
                inStore: true,
                allowMultiFascia: false,
                sortBy: (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.sortBy) || 'distance',
                selectedStoreId: (locationSearchParams === null || locationSearchParams === void 0 ? void 0 : locationSearchParams.locationSearch.type) === LocationSearchType.CUSTOM_SEARCH
                    ? undefined
                    : inStoreFilterState === null || inStoreFilterState === void 0 ? void 0 : inStoreFilterState.storeId,
            }, { enabled: isEnabled }),
            {
                queryKey: ['productCountPerStore', locationSearchParams, urlInfo],
                queryFn: () => SearchAPI.getProductCountPerStore(servicesEndpoint, authenticationConfig, undefined, urlInfo, isShopLanding, getAppliedFilters()),
                enabled: isEnabled,
            },
        ],
        combine: data => {
            var _a, _b;
            const [storesQueryResult, productCountPerStoreResult] = data;
            if (((_a = storesQueryResult.data) === null || _a === void 0 ? void 0 : _a.length) && ((_b = productCountPerStoreResult.data) === null || _b === void 0 ? void 0 : _b.length)) {
                storesQueryResult.data.forEach(store => {
                    var _a;
                    store.itemsCount = (_a = productCountPerStoreResult.data.find(item => item.storeId === store.storeId)) === null || _a === void 0 ? void 0 : _a.itemCount;
                });
            }
            return storesQueryResult;
        },
    });
    const handleClosePopup = () => dispatch(basketActions.createCCPopupCloseAction());
    const updateInStoreFilter = (store) => dispatch(listerActions.updateInStoreFilter(store));
    const updateStoreId = (storeId) => dispatch(urlActions.updateStoreId(storeId));
    const storeFilterApplied = () => dispatch(analyticsActions.storeFilterApplied());
    useEffect(() => {
        const inStoreFilter = LocalStorageUtil.getJsonItem(SELECTED_STORE_STORAGE_KEY);
        if (!activeStoreId &&
            inStoreFilter &&
            (!inStoreFilterState || (inStoreFilterState === null || inStoreFilterState === void 0 ? void 0 : inStoreFilterState.storeId) !== inStoreFilter.storeId)) {
            updateInStoreFilter(inStoreFilter);
        }
    }, [inStoreFilterState]);
    const getAppliedFilters = () => {
        var _a;
        const appliedFilters = ((_a = urlInfo === null || urlInfo === void 0 ? void 0 : urlInfo.filter) === null || _a === void 0 ? void 0 : _a.length)
            ? urlInfo.filter.map(filter => `${filter.filterOn}:${filter.filterValue}`)
            : [];
        return (urlInfo === null || urlInfo === void 0 ? void 0 : urlInfo.defaultFilter) ? appliedFilters.concat(urlInfo.defaultFilter) : appliedFilters;
    };
    const handleSearch = (searchParams) => {
        setLocationSearchParams(searchParams);
    };
    const handleAddToFilter = (store) => {
        const { storeId, storeName } = store;
        updateStoreId(storeId);
        updateInStoreFilter({ storeId, storeName });
        storeFilterApplied();
        LocalStorageUtil.setItem(SELECTED_STORE_STORAGE_KEY, { storeId, storeName });
    };
    return (_jsx(StoreFinderPopup, { isOpen: !popupState.collapsed, urlInfo: urlInfo, type: StoreFinderType.IN_STORE_FILTER, onSearch: handleSearch, storesQueryResult: storesQueryResult, handleClosePopup: handleClosePopup, onStoreSelect: handleAddToFilter }));
};
export default InStoreFilterPopupContainer;
